const productionTemplateList = {
  en: [
    '55107c70c088e6dc80bf2553',
    '54c93f6f836da7c4865460d2',
    '5cffc8bc4899412c91f865e1',
    '5e20e06c460b391727ce7a2b',
    '57e1548d041d8599c91361f5',
    '5d9389e457df5203e183a38e',
    '5c3e2fdb0fa92e43b849d838', // Project management
    '5a69ea0ab14b38d6743530cc',
    '5e110382bbcd021dda283413', // Simple project board
    '5dae5379616fd0851a223f73',
    '5b2281bb004ac866019e51fa',
  ],
  fr: [
    '5c4efa1d25a9692173830e7f',
    '5ec98d97f98409568dd89dff',
    '5994bf29195fa87fb9f27709',
    '5e6005043fbdb55d9781821e',
    '5b78b8c106c63923ffe26520',
    '5aaafd432693e874ec11495c',
    '591ca6422428d5f5b2794aee',
    '5994be8ce20c9b37589141c2',
  ],
  'pt-BR': [
    '5ecbbf6cfb70b949486c7db5',
    '572a431da65e2702e1b056e1',
    '5a7a283369725ba804ce64c5',
    '5c4ef615717f047b64dcda5f',
    '5840836741219c9df38f5cfc',
    '5b6e7929895ea23dbd6329b5',
    '5e6005486e20e75989cf97e4',
    '559bf63a3e9f6b3b0486ffbf',
  ],
};

const stagingTemplateList = {
  en: [
    '5d9e2ce2bc0cfe714f98e30b',
    '5c4244c0ab690061245a4e8a',
    '5ceee0a9806f6241c81eb2d3',
    '5ceedbbc1bb4cf1e56f9b341',
    '5b6e2b4518eebc3e07d205ef',
    '5d9e268bfe3f36439932c2e4',
    '5d24c5fffa5fea058ec1f001',
    '5d9e2d1dcd1008075dc49641',
    '5d9e2c9dbc0cfe714f98e1f8',
    '5f245abe18d10073b082f51b',
    '5d9e328dda98a04647333364',
    '5d9e266b3bdb4d437cf6ac24',
    '5d9e2cb81920cb4605e7ca1b',
    '5d9e2e455c0a1b45bd2e902e',
    '5d9e2df3988ae73d6198efc3',
    '5d1cfebd9eba095c0742bab5',
  ],
  fr: ['5d9e328dda98a04647333364', '5d9e266b3bdb4d437cf6ac24'],
  'pt-BR': [
    '5d9e2c9dbc0cfe714f98e1f8',
    '5d9e2cb81920cb4605e7ca1b',
    '5d9e2e455c0a1b45bd2e902e',
    '5d9e2df3988ae73d6198efc3',
  ],
};

export const getTopTemplates = (
  env: string | undefined,
): { [key: string]: string[] } => {
  if (env === 'prod') {
    return productionTemplateList;
  } else if (env === 'staging') {
    return stagingTemplateList;
  }
  return {};
};
